import { render, staticRenderFns } from "./InfluencersData.vue?vue&type=template&id=39f927e4&"
import script from "./InfluencersData.vue?vue&type=script&lang=js&"
export * from "./InfluencersData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports